import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from './reducer';
import thunkMiddleware from 'redux-thunk'

const persistConfig = {
    key: 'auslink-redux',
    storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const middlewareEnhancer = applyMiddleware(thunkMiddleware)
const composedEnhancers = compose(middlewareEnhancer);

const store = createStore(persistedReducer, undefined, composedEnhancers);
const persistor = persistStore(store);

export { store, persistor };
